import React, { useState, useEffect, useRef } from "react";
import ProductMixRouting from "../Components/ProductsIsotpes/ProductMixRouting";

const Products = () => {
  return <ProductMixRouting />;
};

export default Products;
